import { useMemo } from "react";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useTimerContext } from "../../../context/timer.provider";
import { useEAFDataEntryActions } from "../../../hooks/useEAFDataEntryActions";
import { Process } from "../../../models/eaf.models";
import { DateTimePickerDE } from "../common/DateTimePickerDE";

export type StringFields<T> = {
	[K in keyof T]: T[K] extends Date | null ? K : never;
}[keyof T];

type ProcessDateTimeFieldDEProps = {
	field: StringFields<Process>;
	disableOpenPicker?: boolean;
	disabled?: boolean;
	label?: string;
	format?: string;
	minDateTime?: Date | null;
};
export const ProcessDateTimeFieldDE = ({
	field,
	label,
	format = "HH:mm - DD/MM/YYYY",
	disabled = false,
	disableOpenPicker = false,
	minDateTime,
}: ProcessDateTimeFieldDEProps) => {
	const {
		state: { deProcess },
		actions,
	} = useDataEntryContext();

	const { saveProcess } = useEAFDataEntryActions();
	const { seconds } = useTimerContext();
	const process = deProcess?.process;

	const maxDateTime = useMemo(() => new Date(), [seconds]);

	const onTextValueChange = () => {
		saveProcess(process!);
	};

	return (
		<DateTimePickerDE
			disableOpenPicker={disableOpenPicker}
			disabled={disabled}
			format={format}
			label={label || field}
			value={process ? process![field] : null}
			minDateTime={minDateTime}
			maxDateTime={maxDateTime}
			onChange={(value) => {
				actions.setProcess({
					...process,
					[field]: value,
				});
			}}
			onBlur={() => {
				onTextValueChange();
			}}
		/>
	);
};
